module.exports = __webpack_public_path__ + "img/1506044558.c0174d87.jpg";